import { render } from "./404Page.vue?vue&type=template&id=1013bb96&scoped=true&lang=pug"
import script from "./404Page.vue?vue&type=script&lang=js"
export * from "./404Page.vue?vue&type=script&lang=js"

import "./404Page.vue?vue&type=style&index=0&id=1013bb96&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1013bb96"

export default script